import { RecommendedStrategyResponse } from './Simulations';
import SimulationsRepository from './SimulationsRepository';

export default class SimulationsService {
	private readonly simulationsRepository: SimulationsRepository = new SimulationsRepository();

	async getRecommendedStrategies({
		startDate,
		endDate,
		locationId,
	}: {
		startDate: string;
		endDate: string;
		locationId: string;
	}): Promise<RecommendedStrategyResponse> {
		return await this.simulationsRepository.getRecommendedStrategies({
			startDate,
			endDate,
			locationId,
		});
	}
}
